import React from 'react'

export const Venice = ({ fill }) => (
<svg width="102.917px" height="45.8796px" viewBox="0 0 102.917 45.8796">
<g fill={fill}>
	<g>
		<g>
			<g>
				<g>
					<g>
						<g>
							<path class="st0" d="M14.3306,34.3948c-1.4163,0-2.6216-0.9907-3.5124-1.7233c-0.1949-0.1602-0.3895-0.3203-0.5854-0.4721
								c-0.5117-0.3958-0.6056-1.1317-0.2096-1.6434c0.3958-0.5113,1.1315-0.6058,1.6435-0.2095
								c0.2139,0.1656,0.4268,0.3402,0.6395,0.5151c1.4536,1.195,1.951,1.4441,2.6779,0.9217
								c0.5258-0.3775,1.2575-0.2576,1.6351,0.2677c0.3775,0.5253,0.2578,1.2575-0.2677,1.6351
								C15.6419,34.1959,14.965,34.3948,14.3306,34.3948z"/>
						</g>
					</g>
					<g>
						<g>
							<path class="st0" d="M14.1634,34.395c-0.6345,0-1.311-0.1991-2.0208-0.7093c-0.5253-0.3775-0.6451-1.1098-0.2674-1.6351
								c0.3777-0.5253,1.1094-0.6452,1.6352-0.2672c0.7264,0.5223,1.2236,0.2733,2.6769-0.9219
								c1.1713-0.9626,2.6288-2.1608,4.4756-1.556c0.6148,0.2017,0.9498,0.8634,0.7483,1.4782
								c-0.2017,0.615-0.8634,0.9491-1.4782,0.7485c-0.5803-0.1917-1.2406,0.3031-2.2576,1.1393
								C16.7848,33.404,15.5794,34.395,14.1634,34.395z"/>
						</g>
						<g>
							<path class="st0" d="M25.884,34.3899c-1.3996,0-2.5093-0.9125-3.4898-1.7188c-0.6628-0.5451-1.3483-1.1088-1.8895-1.1758
								c-0.6421-0.0796-1.0981-0.6649-1.0184-1.3068c0.0797-0.6422,0.6637-1.0981,1.3069-1.0185
								c1.2157,0.1508,2.211,0.9691,3.0891,1.6913c0.7089,0.583,1.4417,1.1855,2.0031,1.1855c0.01,0,0.0198-0.0003,0.03-0.0003
								c0.6388,0,1.1613,0.5128,1.1711,1.1537c0.0098,0.6471-0.5067,1.1794-1.1536,1.1891
								C25.9167,34.3897,25.9003,34.3899,25.884,34.3899z"/>
						</g>
					</g>
				</g>
				<g>
					<g>
						<g>
							<path class="st0" d="M25.7399,34.395c-0.6346,0-1.311-0.1991-2.0209-0.7093c-0.5253-0.3775-0.6451-1.1095-0.2674-1.6351
								c0.3775-0.5253,1.1095-0.6452,1.6352-0.2672c0.7268,0.5227,1.2238,0.273,2.6773-0.9219
								c1.1711-0.9626,2.6294-2.1608,4.4754-1.556c0.6148,0.2017,0.9498,0.8634,0.7483,1.4782
								c-0.2017,0.615-0.8637,0.9491-1.4782,0.7485c-0.5815-0.1917-1.2407,0.3033-2.2576,1.1393
								C28.3614,33.4037,27.1558,34.395,25.7399,34.395z"/>
						</g>
						<g>
							<path class="st0" d="M37.483,34.395c-1.4163,0-2.6216-0.9913-3.5125-1.7238c-1.0164-0.8359-1.6771-1.3317-2.2567-1.139
								c-0.6145,0.2011-1.2767-0.1335-1.4783-0.7483s0.1334-1.2769,0.7481-1.4784c1.8466-0.6057,3.304,0.5929,4.475,1.5558
								c1.4536,1.1952,1.9505,1.4456,2.6777,0.9219c0.5251-0.3778,1.2572-0.258,1.635,0.2674
								c0.3777,0.5256,0.2579,1.2575-0.2674,1.6353C38.7944,34.1959,38.1173,34.395,37.483,34.395z"/>
						</g>
					</g>
					<g>
						<g>
							<path class="st0" d="M37.3161,34.395c-0.6345,0-1.311-0.1988-2.0209-0.7091c-0.5253-0.3778-0.6451-1.1098-0.2674-1.6353
								c0.3775-0.5253,1.1096-0.6451,1.6352-0.2674c0.7274,0.5238,1.2242,0.2736,2.6777-0.9219
								c1.1713-0.9628,2.6292-2.1606,4.475-1.5558c0.615,0.2016,0.9498,0.8637,0.7485,1.4784
								c-0.2019,0.6147-0.8637,0.9489-1.4784,0.7483c-0.5797-0.1914-1.24,0.3031-2.2569,1.139
								C39.938,33.4037,38.7323,34.395,37.3161,34.395z"/>
						</g>
						<g>
							<path class="st0" d="M49.0496,34.3917c-1.4334,0-2.6775-0.9842-3.5971-1.7115c-1.0666-0.8439-1.7568-1.3425-2.3483-1.1479
								c-0.6146,0.2011-1.2767-0.1335-1.4781-0.7483c-0.2017-0.615,0.1334-1.2769,0.7483-1.4784
								c1.8304-0.6008,3.3285,0.585,4.5321,1.5369c1.5179,1.2006,2.07,1.4701,2.8064,0.9407
								c0.5256-0.3775,1.2575-0.2576,1.6351,0.2677c0.3775,0.5253,0.2578,1.2575-0.2677,1.6351
								C50.3733,34.1939,49.6924,34.3917,49.0496,34.3917z"/>
						</g>
					</g>
				</g>
				<g>
					<g>
						<g>
							<path class="st0" d="M49.714,34.3206c-0.5103,0-0.9796-0.3359-1.1261-0.851c-0.1772-0.6224,0.1836-1.2705,0.806-1.4477
								c0.4735-0.1348,1.0261-0.5911,1.6119-1.0742c1.1451-0.9448,2.5715-2.1206,4.4986-1.6697
								c0.63,0.1472,1.0216,0.7774,0.8741,1.4076c-0.147,0.63-0.7774,1.0228-1.4073,0.8741
								c-0.7457-0.1747-1.4319,0.3356-2.4743,1.1955c-0.7457,0.6153-1.5168,1.2514-2.4616,1.5204
								C49.9281,34.3061,49.8203,34.3206,49.714,34.3206z"/>
						</g>
						<g>
							<path class="st0" d="M60.7793,34.4131c-1.4113,0-2.653-0.9288-3.6454-1.6706c-0.5921-0.4429-1.1515-0.8611-1.6737-1.0767
								c-0.598-0.2468-0.8828-0.9318-0.6359-1.5298c0.2468-0.598,0.9318-0.883,1.5301-0.6359
								c0.7951,0.3283,1.5003,0.8556,2.1827,1.3658c1.6097,1.2036,2.1936,1.4706,2.9624,0.9173
								c0.5253-0.3778,1.257-0.258,1.6353,0.2674c0.3773,0.5256,0.2575,1.2575-0.2674,1.6353
								C62.1395,34.2089,61.4406,34.4131,60.7793,34.4131z"/>
						</g>
					</g>
				</g>
			</g>
			<g>
				<g>
					<g>
						<g>
							<path class="st0" d="M72.5196,34.767c-1.373,0-2.5425-0.942-3.4084-1.6393c-0.3046-0.2456-0.5929-0.4775-0.8614-0.6562
								c-1.8059-1.2015-2.3853-0.8227-4.8246,0.7726c-0.254,0.166-0.5212,0.3412-0.8055,0.5238
								c-0.5443,0.3493-1.2689,0.192-1.6191-0.3524c-0.3499-0.5443-0.192-1.2692,0.3524-1.619
								c0.2784-0.1787,0.5405-0.3504,0.7894-0.5131c2.5966-1.6988,4.3122-2.8205,7.4054-0.7627
								c0.3574,0.2379,0.7007,0.5146,1.0332,0.7823c1.3749,1.1075,1.8774,1.3554,2.5633,0.8629
								c0.5248-0.3775,1.2569-0.2578,1.6348,0.2677c0.3778,0.5253,0.2578,1.2572-0.2674,1.6351
								C73.8122,34.5715,73.1445,34.767,72.5196,34.767z"/>
						</g>
					</g>
					<g>
						<g>
							<path class="st0" d="M8.2127,30.906c-0.6181,0-1.1351-0.4836-1.1689-1.1083c-0.0051-0.0949,0.0012-0.1876,0.0178-0.2771
								c0.0148-0.1976,0.0788-0.3829,0.1739-0.5357c0.0823-0.1325,0.5389-0.7772,1.4532-0.4732
								C9.3027,28.7159,9.635,29.379,9.431,29.993c-0.0019,0.0059-0.0038,0.0115-0.0059,0.017
								c-0.0131,0.0501-0.0271,0.0902-0.0381,0.1185c-0.1367,0.3534-0.5001,0.7427-1.1101,0.7757
								C8.2555,30.9055,8.234,30.906,8.2127,30.906z"/>
						</g>
						<g>
							<path class="st0" d="M72.3726,34.7747c-0.6702,0-1.3658-0.1999-2.0696-0.7063c-0.5256-0.3778-0.6451-1.1098-0.2674-1.6351
								c0.3775-0.5253,1.1098-0.6452,1.6353-0.2672c0.8172,0.5871,1.6559,0.131,3.3479-1.1863
								c0.3351-0.2609,0.6511-0.507,0.9717-0.7267c0.5342-0.3648,1.2636-0.2286,1.6287,0.3051
								c0.3656,0.5339,0.2289,1.2631-0.3051,1.6287c-0.2614,0.1787-0.5502,0.4037-0.8558,0.6417
								C75.3987,33.6534,73.9586,34.7747,72.3726,34.7747z"/>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g>
			<g>
				<g>
					<g>
						<g>
							<path class="st0" d="M77.1611,31.9718c-0.4058,0-0.8004-0.2111-1.017-0.5883c-0.3224-0.5611-0.1286-1.2771,0.4322-1.5994
								c0.988-0.5677,1.9401-0.7327,2.9116-0.506c0.63,0.1472,1.0211,0.7774,0.8741,1.4076
								c-0.1474,0.6298-0.7772,1.0216-1.4075,0.8741c-0.3809-0.0885-0.7434-0.0122-1.2112,0.2562
								C77.5598,31.9215,77.3589,31.9718,77.1611,31.9718z"/>
						</g>
						<g>
							<path class="st0" d="M84.8277,34.4067c-1.3394,0-2.4388-0.9267-3.2543-1.6139c-1.0526-0.8876-1.7426-1.421-2.6304-1.229
								c-0.633,0.1388-1.2565-0.2642-1.3932-0.8967c-0.1373-0.6323,0.2644-1.256,0.8969-1.393
								c2.0563-0.4472,3.5483,0.8095,4.6367,1.7271c1.3808,1.1634,1.7169,1.273,2.3998,0.7821
								c0.5258-0.3778,1.2572-0.2576,1.6353,0.2677c0.3773,0.5253,0.2576,1.2575-0.268,1.6351
								C86.1273,34.2056,85.4516,34.4067,84.8277,34.4067z"/>
						</g>
					</g>
				</g>
			</g>
			<g>
				<g>
					<g>
						<g>
							<path class="st0" d="M96.5026,34.767c-1.3727,0-2.5422-0.942-3.4079-1.6391c-0.3046-0.2456-0.593-0.4777-0.8614-0.6564
								c-1.806-1.2013-2.3853-0.8227-4.8246,0.7726c-0.2538,0.166-0.5217,0.3412-0.8055,0.5238
								c-0.5446,0.3493-1.2692,0.192-1.6193-0.3524c-0.3496-0.5443-0.192-1.2692,0.3524-1.619
								c0.2784-0.1787,0.5408-0.3504,0.7897-0.5133c2.5961-1.6987,4.311-2.8204,7.4054-0.7625
								c0.3574,0.2379,0.7007,0.5148,1.0332,0.7823c1.3745,1.1075,1.8779,1.3554,2.5628,0.8629
								c0.5256-0.3775,1.2575-0.2578,1.6353,0.2677c0.3773,0.5253,0.2578,1.2575-0.268,1.6351
								C97.7952,34.5715,97.1276,34.767,96.5026,34.767z"/>
						</g>
					</g>
					<g>
						<g>
							<path class="st0" d="M101.6384,30.1069c-0.6194,0-1.1367-0.4854-1.1693-1.1108c-0.0048-0.0946,0.0018-0.1872,0.0186-0.2763
								c0.0148-0.1953,0.0778-0.3789,0.1719-0.5306c0.0814-0.1322,0.536-0.7773,1.4492-0.4783
								c0.6153,0.2008,0.9509,0.8622,0.7501,1.4774c-0.0031,0.0084-0.0056,0.0165-0.0086,0.0249
								c-0.0132,0.0493-0.0269,0.0893-0.0379,0.1175c-0.137,0.3537-0.5011,0.7429-1.1124,0.7747
								C101.6796,30.1064,101.659,30.1069,101.6384,30.1069z"/>
						</g>
						<g>
							<path class="st0" d="M96.3302,34.8077c-0.6194,0-1.3007-0.2044-2.0443-0.7394c-0.525-0.3775-0.6451-1.1098-0.2673-1.6351
								c0.3778-0.5253,1.1101-0.6452,1.6353-0.2672c0.6962,0.5003,0.9199,0.4352,2.1782-0.6348
								c0.2722-0.2311,0.5532-0.4701,0.8662-0.705c0.5176-0.389,1.2524-0.2835,1.6404,0.2337
								c0.3885,0.5174,0.2834,1.2519-0.2339,1.6402c-0.2561,0.1924-0.5097,0.408-0.7551,0.6165
								C98.6012,33.9529,97.5954,34.8077,96.3302,34.8077z"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path class="st0" d="M90.0488,39.8916h-0.6303c-0.6467,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5248-1.1716,1.1716-1.1716
				h0.6303c0.6468,0,1.1716,0.5245,1.1716,1.1716C91.2204,39.3671,90.6957,39.8916,90.0488,39.8916z"/>
		</g>
		<g>
			<path class="st0" d="M85.8615,39.8916h-0.3481c-0.6467,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5248-1.1716,1.1716-1.1716
				h0.3481c0.6467,0,1.1716,0.5245,1.1716,1.1716C87.033,39.3671,86.5082,39.8916,85.8615,39.8916z"/>
		</g>
		<g>
			<path class="st0" d="M80.9127,39.8916H77.008c-0.6473,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5242-1.1716,1.1716-1.1716h3.9047
				c0.6468,0,1.1716,0.5245,1.1716,1.1716S81.5596,39.8916,80.9127,39.8916z"/>
		</g>
		<g>
			<path class="st0" d="M68.8498,39.8916H41.3394c-0.6471,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5245-1.1716,1.1716-1.1716
				h27.5104c0.6467,0,1.1716,0.5245,1.1716,1.1716C70.0213,39.3671,69.4966,39.8916,68.8498,39.8916z"/>
		</g>
		<g>
			<path class="st0" d="M37.6078,39.8916h-0.4339c-0.6471,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5245-1.1716,1.1716-1.1716
				h0.4339c0.647,0,1.1716,0.5245,1.1716,1.1716S38.2549,39.8916,37.6078,39.8916z"/>
		</g>
		<g>
			<path class="st0" d="M73.4273,39.8916H72.993c-0.6468,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5248-1.1716,1.1716-1.1716h0.4342
				c0.6468,0,1.1716,0.5245,1.1716,1.1716S74.0741,39.8916,73.4273,39.8916z"/>
		</g>
		<g>
			<path class="st0" d="M33.6158,39.8916h-6.0752c-0.647,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5245-1.1716,1.1716-1.1716h6.0752
				c0.647,0,1.1716,0.5245,1.1716,1.1716C34.7873,39.3671,34.2629,39.8916,33.6158,39.8916z"/>
		</g>
		<g>
			<path class="st0" d="M24.5896,39.8916h-3.2102c-0.6471,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5245-1.1716,1.1716-1.1716
				h3.2102c0.647,0,1.1716,0.5245,1.1716,1.1716S25.2367,39.8916,24.5896,39.8916z"/>
		</g>
		<g>
			<path class="st0" d="M17.5363,39.8916h-0.0621c-0.6471,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5245-1.1716,1.1716-1.1716
				h0.0621c0.647,0,1.1716,0.5245,1.1716,1.1716C18.7078,39.3671,18.1833,39.8916,17.5363,39.8916z"/>
		</g>
		<g>
			<path class="st0" d="M80.8009,45.8796h-0.2352c-0.647,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5245-1.1716,1.1716-1.1716h0.2352
				c0.6467,0,1.1716,0.5245,1.1716,1.1716C81.9725,45.3551,81.4477,45.8796,80.8009,45.8796z"/>
		</g>
		<g>
			<path class="st0" d="M76.4004,45.8796h-9.1116c-0.6474,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5242-1.1716,1.1716-1.1716
				h9.1116c0.6473,0,1.1716,0.5245,1.1716,1.1716C77.572,45.3551,77.0478,45.8796,76.4004,45.8796z"/>
		</g>
		<g>
			<path class="st0" d="M62.8618,45.8796H39.9503c-0.647,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5245-1.1716,1.1716-1.1716
				h22.9115c0.6473,0,1.1716,0.5245,1.1716,1.1716C64.0334,45.3551,63.5091,45.8796,62.8618,45.8796z"/>
		</g>
		<g>
			<path class="st0" d="M36.0455,45.8796h-6.5092c-0.6471,0-1.1716-0.5245-1.1716-1.1716c0-0.647,0.5245-1.1716,1.1716-1.1716
				h6.5092c0.6471,0,1.1716,0.5245,1.1716,1.1716C37.217,45.3551,36.6925,45.8796,36.0455,45.8796z"/>
		</g>
		<g>
			<path class="st0" d="M24.8505,45.8796v-0.0003c-0.0081,0.0003-0.0164,0.0003-0.0245,0.0003h-0.2887l0.1566-1.1716l-0.1566-1.1716
				h0.2887c0.0081,0,0.0164,0,0.0245,0.0003v-0.0003c0.6471,0,1.1716,0.5245,1.1716,1.1716
				C26.0221,45.3551,25.4976,45.8796,24.8505,45.8796z"/>
		</g>
	</g>
	<g>
		<path class="st0" d="M44.5549,24.8379c-4.5273,0-14.1244-0.1533-20.4623-1.3401c-4.4489-0.8329-8.042-2.9427-10.1175-5.9404
			c-1.1365-1.6414-2.1868-3.3052-2.55-5.6038c-0.1349-0.8533-0.187-1.7423-0.2373-2.6023
			c-0.0135-0.2313-0.0269-0.4602-0.0417-0.6868c-0.0732,0.1223-0.1702,0.2331-0.2899,0.3252
			c-0.9372,0.7218-2.081,0.7398-3.0596,0.048c-1.2538-0.8863-1.922-2.6817-1.4898-4.0023c0.5216-1.5934,1.9042-2.6663,3.4403-2.6693
			c0.0021,0,0.0044,0,0.0065,0c1.4261,0,2.6236,0.9401,3.1262,2.4552c0.4735,1.4269,0.5617,2.9345,0.6472,4.3928
			c0.0492,0.8403,0.0956,1.634,0.2126,2.3737c0.287,1.816,1.1125,3.1198,2.162,4.6357c1.7219,2.487,4.784,4.2525,8.6222,4.9713
			c8.1275,1.522,22.3793,1.284,22.5223,1.2819c0.2451-0.0008,22.7453-0.0689,27.9772-1.5196
			c5.9951-1.6626,9.0349-4.6113,9.0349-8.7644c0-0.6471,0.5242-1.1716,1.1716-1.1716c0.6468,0,1.1716,0.5245,1.1716,1.1716
			c0,3.6682-1.8656,8.5579-10.7521,11.0221c-5.5339,1.5346-27.6411,1.6028-28.5793,1.6049
			C46.9308,24.8222,46.0017,24.8379,44.5549,24.8379z M10.1404,6.8903c0.3286,0,0.6537,0.1375,0.8832,0.4007
			c-0.0758-0.6074-0.1871-1.1876-0.3676-1.7316c-0.1287-0.3877-0.3897-0.8499-0.9025-0.8499c-0.0005,0-0.001,0-0.0016,0
			c-0.4206,0.001-0.9811,0.3316-1.218,1.0551c-0.0926,0.2827,0.1712,1.046,0.6154,1.36c0.1505,0.107,0.1749,0.0877,0.2769,0.0094
			C9.6393,6.9696,9.8908,6.8903,10.1404,6.8903z"/>
	</g>
	<g>
		<path class="st0" d="M44.5546,27.9621c-4.5271,0-14.1241-0.1533-20.462-1.3401c-1.1085-0.2074-2.1797-0.4973-3.1836-0.8614
			c-0.6082-0.2207-0.9225-0.8927-0.702-1.5008c0.2205-0.6084,0.8925-0.9225,1.5008-0.702c0.8847,0.3209,1.8321,0.5769,2.8159,0.7612
			c8.1275,1.5219,22.3793,1.2837,22.5223,1.2819c0.2451-0.0008,22.7453-0.0689,27.9772-1.5196
			c2.8958-0.8031,4.9212-1.7032,6.3732-2.8328c0.5113-0.3964,1.2471-0.3051,1.6442,0.2057
			c0.3972,0.5108,0.3051,1.2468-0.2055,1.6442c-1.7019,1.3234-3.9855,2.353-7.186,3.2406
			c-5.5339,1.5346-27.6411,1.6028-28.5793,1.6049C46.9308,27.9463,46.0015,27.9621,44.5546,27.9621z"/>
	</g>
	<g>
		<path class="st0" d="M13.0803,29.9435c-0.305,0-0.6094-0.1183-0.8391-0.354c-2.8345-2.908-5.756-7.4245-5.8789-7.6154
			c-0.1518-0.2354-0.2141-0.5176-0.1757-0.795c0.5288-3.8259,1.251-6.7253,2.3417-9.4012c0.3739-0.9176,0.3943-1.7925,0.3018-2.07
			C8.3937,9.3099,8.3184,8.6384,8.675,8.151c0.3821-0.522,1.1154-0.6354,1.6374-0.2538c1.2317,0.9013,1.0634,3.1016,0.3858,4.7648
			c-0.973,2.3874-1.6344,4.9936-2.1291,8.4034c0.7461,1.1212,3.1251,4.6061,5.3501,6.8888
			c0.4516,0.4632,0.4422,1.2049-0.0212,1.6567C13.6703,29.8329,13.3752,29.9435,13.0803,29.9435z"/>
	</g>
	<g>
		<path class="st0" d="M66.7462,23.3878c-0.0204,0-0.0409-0.0005-0.061-0.0015c-0.6463-0.0333-1.143-0.584-1.1102-1.23
			c0.0012-0.0221,0.0872-1.7289,0.0613-3.2546c-2.363,0.7696-3.0346,3.4524-3.0659,3.5826c-0.1503,0.6273-0.7798,1.016-1.408,0.87
			c-0.6277-0.1477-1.0187-0.7724-0.8741-1.4009c0.43-1.8659,2.3231-5.4365,6.4118-5.5941c0.6295-0.0155,1.1574,0.446,1.2122,1.0681
			c0.1571,1.7876,0.0092,4.7249,0.0028,4.849C67.8832,22.9019,67.3656,23.3878,66.7462,23.3878z"/>
	</g>
	<g>
		<path class="st0" d="M82.4316,32.9225c-0.4144,0-0.8161-0.2204-1.0286-0.6097c-0.3102-0.5673-0.1022-1.2786,0.4642-1.5893
			c0.035-0.0194,2.7733-1.5463,4.7055-4.1193c1.3917-1.8526,2.0513-3.5528,1.5535-7.2247c-0.087-0.641,0.3621-1.2313,1.0033-1.3183
			c0.6422-0.087,1.2316,0.3623,1.3185,1.0035c0.601,4.4305-0.3201,6.708-2.0014,8.9464c-2.249,2.9945-5.3241,4.6965-5.4536,4.7673
			C82.8143,32.8761,82.6218,32.9225,82.4316,32.9225z"/>
	</g>
	<g>
		<path class="st0" d="M89.8434,20.2513c-0.4567,0-0.8909-0.2687-1.0796-0.7162c-0.2517-0.5962,0.0275-1.2834,0.6234-1.5349
			c0.242-0.1022,0.3987-0.3379,0.3987-0.6005V3.435c-0.0679-0.0313-0.1485-0.0659-0.2161-0.0948l-0.1734-0.0753
			c-0.5924-0.2603-0.8619-0.9514-0.601-1.5438c0.2598-0.5929,0.9519-0.8622,1.5438-0.601l0.1544,0.0666
			c0.6114,0.2624,1.6355,0.7012,1.6355,2.1542v14.0589c0,1.2066-0.7188,2.2897-1.8306,2.7591
			C90.1497,20.2216,89.9955,20.2513,89.8434,20.2513z"/>
	</g>
	<g>
		<path class="st0" d="M85.2298,12.9738c-0.6474,0-1.1716-0.5245-1.1716-1.1716V6.0207c0-2.8414,2.3111-5.153,5.1525-5.153h0.1083
			c0.4144,0,0.6987,0.198,0.8489,0.3305c0.3465,0.22,0.5667,0.6155,0.5423,1.0544c-0.0357,0.646-0.5883,1.1426-1.2346,1.105
			c-0.1999-0.0112-0.3666-0.0677-0.5008-0.1367c-1.4396,0.12-2.5734,1.3299-2.5734,2.8v5.7816
			C86.4014,12.4494,85.8767,12.9738,85.2298,12.9738z"/>
	</g>
	<g>
		<path class="st0" d="M28.6686,16.7834c-1.4597,0-2.6471-1.1095-2.6471-2.4733c0-0.328,0.0676-0.647,0.2012-0.9483
			c0.2618-0.5916,0.9545-0.8588,1.5455-0.5967c0.5916,0.2618,0.8589,0.9539,0.5967,1.5455c0.0076,0.0249,0.105,0.1296,0.3035,0.1296
			c0.1985,0,0.2958-0.1047,0.3043-0.1327c-0.1875-0.6194,0.1626-1.2699,0.7818-1.4576c0.6202-0.1871,1.2735,0.1656,1.461,0.7849
			c0.0663,0.2189,0.0999,0.4462,0.0999,0.6753C31.3156,15.6739,30.1282,16.7834,28.6686,16.7834z"/>
	</g>
	<g>
		<path class="st0" d="M32.3947,24.126c-0.2663,0-0.534-0.0902-0.7537-0.2751l-3.6613-3.0815
			c-0.2645-0.2227-0.4172-0.5507-0.4172-0.8965v-2.8638c0-0.6471,0.5245-1.1716,1.1716-1.1716c0.6471,0,1.1716,0.5245,1.1716,1.1716
			v2.3185l3.244,2.7304c0.4951,0.4167,0.5587,1.1558,0.142,1.6508C33.06,23.9842,32.7286,24.126,32.3947,24.126z"/>
	</g>
	<g>
		<path class="st0" d="M10.4808,37.9026c-1.082,0-1.7797-0.3959-2.1927-0.7597c-0.7461-0.6575-1.1405-1.6897-1.1405-2.9848
			c0-0.2497,0.0798-0.4927,0.2276-0.6939c1.7117-2.3291,10.3613-10.0597,11.9192-11.4457c0.105-0.1746,0.2493-0.3127,0.4152-0.4088
			l19.1518-20.373c0.4435-0.4717,1.1849-0.4945,1.6561-0.0511c0.4715,0.4431,0.4943,1.1846,0.0512,1.6559L21.1581,23.4899
			c-0.9117,1.6426-5.2272,9.2701-9.3245,13.9792c-0.1889,0.2171-0.4511,0.357-0.7367,0.3931
			C10.8791,37.8899,10.6738,37.9026,10.4808,37.9026z M9.5104,34.5392c0.0435,0.3972,0.1574,0.6964,0.3268,0.8459
			c0.134,0.118,0.3381,0.1638,0.5479,0.1732c1.6283-1.9292,3.3029-4.3428,4.7531-6.5933
			C12.7668,31.1722,10.4726,33.3867,9.5104,34.5392z"/>
	</g>
</g>
</svg>
)

